import { render, staticRenderFns } from "./shrink.vue?vue&type=template&id=978c1cb6&scoped=true&"
import script from "./shrink.vue?vue&type=script&lang=js&"
export * from "./shrink.vue?vue&type=script&lang=js&"
import style0 from "./shrink.vue?vue&type=style&index=0&id=978c1cb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978c1cb6",
  null
  
)

export default component.exports